/* eslint-disable */
import './css/autocomplete-style.scss'

/***
 * Système d'autocompletion sur des champs de formulaire
 */
/*! function() {
    document.addEventListener('DOMContentLoaded', function() {
        console.log('coucou vue de la class')
        initAutocomplete();
    });
}();

/**
 * Classe d'autocompletion
 */
export class Autocomplete {
    // Constructeur
    constructor(selector, params = {}) {
        if (!selector || selector == null) {
            console.warn(this.getAlerts('bad-initialization'));
            return;
        }

        this.selector = selector;
        this.results = [];
        this.classes = params.classes;
        this.allowTownSearch = params.allowTownSearch || selector.hasAttribute('data-autocomplete-town-search'); //Autorise la recherche de ville
        this.allowDepartmentSearch = params.allowDepartmentSearch || selector.hasAttribute('data-autocomplete-department-search'); //Autorise la recherche de département
        this.allowRegionSearch = params.allowRegionSearch || selector.hasAttribute('data-autocomplete-region-search'); //Autorise la recherche de région
        this.multiSelect = params.type == "multi" || (selector.hasAttribute('data-autocomplete-type') && selector.getAttribute('data-autocomplete-type') == 'multi'); //Autorise le mulitchoix
        this.autoLocate = params.autoLocate || selector.hasAttribute('data-autocomplete-autolocate'); //Affiche le bouton pour localiser l'utilisateur
        this.minCharForSearch = 2 //Nombre minimum de caractère à saisir avant le déclenchement de la recherche //Todo permettre le paramétrage de cette valeur
        this.triggerField = null;

        this.prepareDom();
        this.initializeEvents();
        this.getResultsFromRequest();
    }

    /**
     * Ajoute les éléments nécessaires à l'autocompletion
     */
    prepareDom() {
        this.createWrapper();
        this.createChoicesWrapper();
        this.createResultWrapper();
        this.createAutoLocateWrapper();
        this.createTriggerHiddenField();
        this.createLoader();
    }

    /**
     * Créé le container du champ d'autocompletion
     */
    createWrapper() {

        let parent = this.selector.parentNode;

        let wrapper = document.createElement('div');
        wrapper.classList.add('autocomplete-wrapper');

        if (this.classes && this.classes.wrapper && this.classes.wrapper != "") {
            wrapper.classList.add(this.classes.wrapper);
        }

        this.wrapper = parent.insertBefore(wrapper, this.selector);
        wrapper.appendChild(this.selector);
    }

    /**
     * Binde les événements sur les frappes au clavier
     */
    initializeEvents() {
        let ref = this;

        //Entrée de saisie
        this.selector.addEventListener('keydown', function() {
            ref.cleanChoices();
            ref.showLoader();
        });

        //Sortie de champ
        this.selector.addEventListener('blur', function() {
            ref.hideLoader();
            if (this.value == "") {
                ref.emptyResults();
            }
        });

        // Fin d'entrée de saisie
        this.selector.addEventListener('keyup', debounce(function() {
            let query = ref.selector.value;

            if (query !== '' && query.length >= ref.minCharForSearch) {
                ref.search();
            } else {
                ref.hideLoader();
            }
        }, 300));
    }

    /**
     * Effecue la requête vers l'API localisation
     */
    search() {
        let ref = this;
        let path = php_vars.ajaxurl;
        let xhr = new XMLHttpRequest();
        let parameters = {
            'action': 'autocomplete',
            'term': ref.selector.value,
            'town-search': ref.allowTownSearch,
            'department-search': ref.allowDepartmentSearch,
            'regions-search': ref.allowRegionSearch
        }
        xhr.open('GET', path + formatParams(parameters), true);
        xhr.send(parameters);
        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
                let response = JSON.parse(xhr.responseText);
                let datas = response.data;
                if (datas.regions) { ref.addRegionsToChoices(datas.regions); }
                if (datas.departments) { ref.addDepartmentsToChoices(datas.departments); }
                if (datas.towns) { ref.addTownsToChoices(datas.towns); }
                ref.hideLoader();
            } else {
                console.warn('La requête vers ' + path + formatParams(parameters) + ' a échoué');
            }
        }
    }

    /**
     * Effecue la requête vers l'API localisation via le champ caché
     */
    searchByCode(code) {
        let ref = this;
        let path = php_vars.ajaxurl;
        let xhr = new XMLHttpRequest();
        let parameters = {
            'action': 'autocomplete_by_code',
            'code': code,
        }
        xhr.open('GET', path + formatParams(parameters), true);
        xhr.send(parameters);
        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
                let response = JSON.parse(xhr.responseText);
                let region = response.data;

                let item = {
                    'type': 'region',
                    'id': region.id,
                    'name': region.name
                }

                ref.addChoiceToResults(item);
                ref.hideLoader();
            } else {
                console.warn('La requête vers ' + path + formatParams(parameters) + ' a échoué');
            }
        }
    }

    //#region Choix

    /**
     * Créé le container de choix
     */
    createChoicesWrapper() {
        let wrapper = document.createElement('div');
        wrapper.classList.add('autocomplete-choices-wrapper');

        if (this.classes && this.classes.wrapper && this.classes.choices != "") {
            wrapper.classList.add(this.classes.choices);
        }

        this.wrapper.appendChild(wrapper);
        this.choicesWrapper = wrapper;
    }

    /**
     * Supprime les choix actuels
     */
    cleanChoices() {
        this.choicesWrapper.innerHTML = '';
    }

    /**
     * Ajoute les choix retrounés par l'API dans le wrapper de choix
     * @param { Le titre des résultats} title 
     * @param { Les choix proposés } choices 
     */
    addChoices(title = "", choices = []) {
        let ref = this;
        if (!choices || choices.length == 0) { return; }

        let wrapper = document.createElement('ul');
        wrapper.classList.add('autocomplete-choices');

        if (title && title != "") {
            let titleWrapper = document.createElement('li');
            titleWrapper.classList.add('autocomplete-choices-title');

            if (this.classes && this.classes.choices && this.classes.choices != "") {
                titleWrapper.classList.add(this.classes.choices + '-title');
            }

            titleWrapper.innerHTML = title;
            wrapper.appendChild(titleWrapper);
        }

        choices = choices.reverse(); // TODO: check that
        choices.forEach(item => {
            if (!ref.isInResults(item)) {
                let elt = document.createElement('li');
                elt.classList.add('autocomplete-choices-item');

                if (this.classes && this.classes.choices && this.classes.choices != "") {
                    elt.classList.add(this.classes.choices + '-item');
                }

                elt.innerHTML = item.name;

                wrapper.appendChild(elt);
                elt.addEventListener('click', function() {
                    ref.addChoiceToResults(item);
                });
            }
        });

        this.choicesWrapper.appendChild(wrapper);
    }

    /**
     * Ajoute les résultats de type région
     * @param { Les régions à ajouter } regions 
     */
    addRegionsToChoices(regions) {
        let choices = [];
        regions.forEach(region => {
            let item = {
                'type': 'region',
                'id': region.id,
                'name': region.name
            }
            choices.push(item);
        });
        this.addChoices("Régions", choices);
    }

    /**
     * Ajoute les résultats de type département
     * @param { Les départements à ajouter } departments 
     */
    addDepartmentsToChoices(departments) {
        let choices = [];
        departments.forEach(department => {
            let item = {
                'type': 'department',
                'id': department.id,
                'name': department.name + ' (' + department.code + ')'
            }
            choices.push(item);
        });
        this.addChoices("Départements", choices);
    }

    /**
     * Ajoute les résultats de type ville
     * @param { Les villes à ajouter } towns 
     */
    addTownsToChoices(towns) {
        let choices = [];
        let error = false;

        const fieldLand = document.getElementById('filter_sector_town') != null ? document.getElementById('filter_sector_town') : document.getElementById('filter_sector_Land');
        let departmentNumber = "";
        if (fieldLand != null) {
            departmentNumber = fieldLand.hasAttribute('departmentnumber') ? fieldLand.getAttribute('departmentnumber') : "";
        }

        //On formate le code département
        if (departmentNumber.length == 1)
        {
            departmentNumber = '0'+departmentNumber
        }

        towns.forEach(town => {
            let zipcode = town.zipcode.toString()
            // console.log(zipcode.substring(0,2))
  
           
            // console.log('je suis le dpt code : ' + departmentNumber)
            if ((zipcode.substring(0,2) === departmentNumber) || departmentNumber == "" ) {
                let item = {
                    'type': 'town',
                    'id': town.id,
                    'insee': town.insee,
                    'name': town.name + ' (' + town.zipcode + ')'
                }
                choices.push(item);
            } else {
                error = true;
            }
        });
        if (choices.length == 0 && error == true) {
            alert('Vous devez choisir une ville dans le departement du modèle (' + departmentNumber + ')')
        }
        this.addChoices("Villes", choices);
    }

    //#endregion

    //#region Loader

    /**
     * Créée le loader
     */
    createLoader() {
        let loader = this.wrapper.querySelector('.autocomplete-loader');

        if (loader == null) {
            loader = document.createElement('div');
            loader.classList.add('autocomplete-loader');

            if (this.classes && this.classes.loader && this.classes.loader != "") {
                loader.classList.add(this.classes.loader);
            }

            let spinner = document.createElement('div');
            spinner.classList.add('lds-spinner');

            for (var i = 0; i < 12; i++) {
                let spin = document.createElement('div');
                spinner.append(spin);
            }

            loader.appendChild(spinner);

            this.wrapper.appendChild(loader);
            this.loader = loader;
        }
    }

    /**
     * Affiche l'indicateur de chargement de résultats
     */
    showLoader() {
        if (!this.loader) { this.createLoader() }
        if (!this.loader.classList.contains('loading')) {
            this.loader.classList.add('loading')
        }

        if (this.autoLocateWrapper) {
            this.autoLocateWrapper.classList.add('hide');
        }
    }

    /**
     * Cache l'indicateur de chargement de résultats
     */
    hideLoader() {
        if (this.loader) {
            this.loader.classList.remove('loading');
        }


        if (this.autoLocateWrapper) {
            this.autoLocateWrapper.classList.remove('hide');
        }
    }

    //#endregion

    //#region Résultats

    /**
     * Créer le container de résultats
     */
    createResultWrapper() {
        //Création du wrapper pour l'affichage visuel des résultats sélectionnés
        if (this.multiSelect) {
            let wrapper = document.createElement('div');
            wrapper.classList.add('autocomplete-multiselect-wrapper');
            if (this.classes && this.classes.results && this.classes.results != "") {
                wrapper.classList.add(this.classes.results);
            }
            this.wrapper.parentNode.appendChild(wrapper);
            this.resultWrapper = wrapper;
        }
        this.resultsField = this.addHiddenField('autocomplete-results', null, this.results);
    }

    /**
     * Ajoute un champ caché dans le container de l'autocomplétion
     * @param { Le nom du champ caché } name 
     * @param { L'id du champ caché } id
     * @param { La valeur par défaut du champ caché } 
     */
    addHiddenField(name, id = null, value = null) {
        let input = this.wrapper.querySelector('[name="' + name + '"]');

        if (!input || input.length == 0) {
            input = document.createElement('input');
            input.setAttribute("name", name);
            input.setAttribute("id", id == null ? name : id);
            input.setAttribute("value", value != null ? value : "");
            input.setAttribute("type", "hidden");

            this.wrapper.appendChild(input);

            return input;
        }
    }

    /**
     * Ajoute un champ caché qui ajoute une valeur dans les choix lorsque la valeur est modifiée
     */
    createTriggerHiddenField() {
        let input = document.createElement('input');
        input.setAttribute("name", "autocomplete-trigger-field");
        input.setAttribute("id", "autocomplete-trigger-field");
        input.setAttribute("type", "region") // région par défaut, possibilité de le passer en département (ou en ville ?)
        input.setAttribute("value", "");
        input.setAttribute("type", "hidden");

        this.wrapper.appendChild(input);

        this.triggerField = input;

        //On observe le champ
        let ref = this;
        const targetNode = input;
        var config = { attributes: true };

        const callback = function(mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes') {

                    if (targetNode.value == "") {
                        ref.emptyResults();
                    } else {
                        ref.showLoader();
                        ref.searchByCode(targetNode.value);
                    }

                    break;
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);

        return input;
    }

    /**
     * Vérifie qu'un choix est déjà dans les résultats sélectionnés
     * @param { Le choix à tester } item 
     */
    isInResults(item) {
        return this.results.some(r => r.id == item.id);
    }

    /**
     * Ajoute un choix à la liste des résultats
     * @param { le choix à ajouter aux résultats } item 
     */
    addChoiceToResults(item) {

        if (!this.multiSelect) {
            this.selector.value = item.name;
            this.results = [];
        } else if (!this.isInResults(item)) {
            this.addChip(item);
            this.selector.value = "";
        }

        if (!this.isInResults(item)) { this.results.push(item); }

        this.saveResults();
        this.cleanChoices();
    }

    /**
     * Supprimer un choix des résultats
     * @param {Le choix a supprimer des résultats } item 
     */
    removeChoiceFromResults(item) {
        const index = this.results.indexOf(item);

        if (index > -1) {
            this.results.splice(index, 1);
        }

        this.saveResults();
    }

    /**
     * Sauvegarde les résultats
     */
    saveResults() {
        this.resultsField.value = JSON.stringify(this.results);
    }

    /** Vide le champ des résultats (Remise à 0) */
    emptyResults() {
        this.resultsField.value = "";
    }

    /**
     * Ajoute un tag correspondant au choix sélectionné
     * @param { Le choix à ajouter en tag } item 
     */
    addChip(item) {
        let ref = this;
        let chip = document.createElement('button');
        chip.classList.add('chip');

        if (this.classes && this.classes.chip && this.classes.chip != "") {
            titleWrapper.classList.add(this.classes.chip);
        }
        chip.setAttribute('id', item.id);
        chip.innerHTML = item.name;
        chip.title = "Supprimer la recherche " + item.name;

        let closeWrapper = document.createElement('span');
        closeWrapper.classList.add('chip-close');
        let closeIcon = document.createElement('span');
        let closeInfo = document.createElement('span');

        closeIcon.classList.add('chip-close-icon');
        closeIcon.innerHTML = "X";
        closeInfo.classList.add('sr-only');
        closeInfo.innerHTML = "Supprimer la recherche " + item.name;

        closeWrapper.append(closeIcon, closeInfo);
        chip.appendChild(closeWrapper);

        chip.addEventListener('click', function() {
            ref.removeChip(chip);
            ref.removeChoiceFromResults(item);
        });

        this.resultWrapper.appendChild(chip);
    }

    /**
     * Supprime un tag
     * @param { Le tag a supprimer des résultats } chip 
     */
    removeChip(chip) {
        chip.parentNode.removeChild(chip);
    }

    /**
     * Récupère les données de recherche de la requête, envoyées via une variable js dans le PHP
     */
    getResultsFromRequest() {
        if (typeof autocomplete_search == "undefined") { return; }

        if (autocomplete_search.autocomplete_search_label != "") {
            let item = {
                'type': autocomplete_search.autocomplete_search_type,
                'name': autocomplete_search.autocomplete_search_label,
                'id': autocomplete_search.autocomplete_search_id
            };

            if (!this.isInResults(item)) {

                if (this.multiSelect) {
                    this.addChip(item);
                } else {
                    this.selector.value = autocomplete_search.autocomplete_search_label;
                }

                this.results.push(item);

            }

            this.saveResults();
        }
    }

    //#endregion

    //#region AutoLocate

    /**
     * Créée le bouton d'auto localisation
     */
    createAutoLocateWrapper() {
        if (!this.autoLocate || !navigator.geolocation) { return; }

        let ref = this;
        let wrapper = document.createElement('div');
        wrapper.classList.add('autocomplete-autolocate-wrapper');
        if (this.classes && this.classes.autolocate && this.classes.autolocate != "") {
            wrapper.classList.add(this.classes.autolocate);
        }

        let button = document.createElement('button');
        button.type = "button";
        button.classList.add('autocomplete-autolocate-button');

        if (this.classes && this.classes.autolocate && this.classes.autolocate != "") {
            button.classList.add(this.classes.autolocate + '-button');
        }

        let buttonIcon = document.createElement('span');
        buttonIcon.classList.add('icon-localisation');
        buttonIcon.setAttribute('aria-hidden', true);

        let buttonSr = document.createElement('span');
        buttonSr.classList.add('sr-only');
        buttonSr.innerHTML = "Me localiser";

        button.append(buttonIcon, buttonSr);
        wrapper.appendChild(button);

        button.addEventListener('click', function() {
            ref.autoLocateUser();
        });

        this.wrapper.appendChild(wrapper);
        this.autoLocateWrapper = wrapper;
    }

    /**
     * Définit la localisation de l'internaute
     * TODO : à tester en environnement sécurisé
     */
    autoLocateUser() {
        let ref = this;

        this.showLoader();

        let options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        let latitude = 48.132786290615584;
        let longitude = -1.6357313459752505;

        function geoSuccess(position) {
            latitude = position.coords.latitude;
            longitude = positions.coords.longitude;
        }

        function geoError(err) {
            console.warn(`ERREUR (${err.code}): ${err.message}`);
        }

        navigator.geolocation.getCurrentPosition(geoSuccess, geoError, options);

        let xhr = new XMLHttpRequest();
        let url = "https://api-adresse.data.gouv.fr/reverse/?lat=" + latitude + "&lon=" + longitude;
        xhr.open('GET', url, true);
        xhr.send();
        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
                let response = JSON.parse(xhr.response);
                let infos = response.features[0].properties;
                let townName = infos.city;
                let zipCode = infos.postcode;
                ref.getItemFromAutoLocate(townName, zipCode);
            }
        }
    }

    getItemFromAutoLocate(townName, zipCode) {
        let ref = this;
        if (townName == null || zipCode == null) { return; }
        let xhr = new XMLHttpRequest();
        let parameters = {
            'action': 'get_location_from_town_name',
            'name': townName,
            'zipcode': zipCode
        }

        let path = php_vars.ajaxurl;

        xhr.open('GET', path + formatParams(parameters), true);
        xhr.send(parameters);
        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
                let response = JSON.parse(xhr.responseText);
                let data = response.data;

                let item = {
                    "type": "town",
                    "id": data.id,
                    "name": data.name + " (" + data.zipcode + ")"
                }

                ref.addChoiceToResults(item);
                ref.hideLoader();

            } else {
                console.warn('La requête vers ' + path + formatParams(parameters) + ' a échoué');
            }
        }
    }

    //#endregion

    //#region Utils

    /**
     * Récupère un élément du DOM via son sélecteur
     */
    findElementBySelector(elementSelector = null, defaultSelector) {
        let element = null;

        //Sélecteur custom
        element = document.querySelector(elementSelector);
        if (element && element != null) {
            return element;
        }

        //Sélecteur par défaut
        element = document.querySelector(defaultSelector);
        if (element && element != null) {
            return element;
        }

        this.getAlerts('element-not-found', elementSelector);

        return element;
    }

    /**
     * Gestionnaire d'alerte
     * @param {} alertType Type d'alerte 
     */
    getAlerts(alertType, elt) {
        let alertMessage = alertType;
        switch (alertType) {
            case 'bad-initialization':
                alertMessage = "Le champ d'autocompletion n'a pas été trouvé";
                break;
            case 'element-not-found':
                alertMessage = "L'élément n'a pas été trouvé (" + elt + ")";
                break;
        }
        console.error('[Autocomplete]', alertMessage);
    }

    //#endregion
}

/**
 * Active automatiquement l'autocompletion pour les champs possédant l'attribut entities-autocomplete
 */

function initAutocomplete() {
    let fields = document.querySelectorAll('[data-entities-autocomplete]');
    let options = {
        allowTownSearch: true,
        allowDepartmentSearch: true,
        allowRegionSearch: true,
        // type: "multi",
        classes: {
            'wrapper': 'mfc-autocomplete-wrapper',
            'field': 'mfc-autocomplete-field',
            'choices': 'mfc-autocomplete-choices',
            'results': 'mfc-autocomplete-results',
            'autolocate': 'mfc-autocomplete-autolocate'
        }
    }

    fields.forEach(field => {
        new Autocomplete(field, options);
    });
}

//#region Utils

/**
 * Formatte un objet en query string
 * @param { paramètres à traiter} params 
 */

function formatParams(params) {
    return "?" + Object
        .keys(params)
        .map(function(key) {
            return key + "=" + encodeURIComponent(params[key])
        })
        .join("&")
}
/**
 * Déclenche une action au bout d'un délai
 * @param { La fonction a exéctuter} callback 
 * @param { Le temps de latence à appliquer avant le déclenchement de la fonction } delay 
 */

function debounce(callback, delay) {
    var timer;
    return function() {
        var args = arguments;
        var context = this;
        clearTimeout(timer);
        timer = setTimeout(function() {
            callback.apply(context, args);
        }, delay)
    }
}
//#endregion